var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardSkeleton',[_c('HeaderSkeleton',{attrs:{"width":"100%","height":"14px"}}),_c('LineSkeleton',{attrs:{"width":"100%","height":"60px"}}),_c('br'),_c('div',{staticClass:"call-to-action"},[_c('LineSkeleton',{attrs:{"width":"100%"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }